import React, { useEffect, useState } from 'react';
import FormHelper from '../../../components/FormBuilder/FormHelpers';
import { FieldLabel, Description, RequiredMsg, FieldReview } from '../FieldLabel';
import { CueTip } from '../../../components/Common/CueTooltip';
import TagService from '../../Tags/TagService';
import { Spinner } from '../../Common/Spinner';

const InputTags = ({renderField, position, field, formData, listPreviousTags, readOnly, errors, formFn, isFormWizard, openFieldLabelModal, currentLocale, fieldReview}) => {
  
  const clientId = field.client_id;
  const listKey = clientId + '_array';
  formData[listKey] = formData[listKey] || [];
  
  let [modelarray, setModelarray] = useState(formData[listKey]);
  let [showError, setShowError] = useState(false);
  const [tagList, setTagList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTagsPanel, setShowTagsPanel] = useState(false);

   useEffect(()=>{
    if(renderField) getPreviousTags();
  }, [renderField])
  
  if(!renderField){
    return null
  }

  let inputAttributes = {
    'id': clientId,
    'name': clientId,
    'placeholder': field.placeholder,
    'disabled':readOnly,
    'className':'form-input form-input-gray form-input-full'
  }

  let parentAttributes = {
    'tooltip': field.tooltip
  }

  let labelAttributes = FormHelper.setLabelStyle(field, isFormWizard, parentAttributes);
  
  const getPreviousTags = async () =>{
    if(!listPreviousTags) return;
    setLoading(true);
    const {status, data} = await TagService.getAll({
      'page': 1,
      'per_page': 100,
      'organization_id': formFn.organization_id,
      'taggable_type': formFn.taggable_type
    })
    if(status === 200){
      setTagList(data.tags?.map(t => t.tag));
      setLoading(false);
    }
  }

  const crateNewTag = async (tag) =>{
    if(!listPreviousTags) return;
    setLoading(true);
    const {status, data} = await TagService.create({
      'organization_id': formFn.organization_id,
      'taggable_type': formFn.taggable_type,
      'tag':tag
    });
    if(status === 201){
      setTagList([tag, ...tagList]);
      setLoading(false);
    }
  }

  const onEnter = (event) =>{
    if (event.key === 'Enter') {
      event.preventDefault();
      add(event.target.value);
      event.target.value = null;
    }
  }
  
  /* 
   * To add items;
  */
  const add = (value) => {
    if(value==null || (value && modelarray.includes(value))) return;
    setModelarray([...modelarray, value]);
    formData[listKey].push(value);
      
    /*Storing Result as string*/
    formData[clientId] = modelarray.toString();  
    setError();
    if(!tagList.includes(value)){
      crateNewTag(value); // add to db
    } 
  }

  const remove = (e, item) => {
    e.preventDefault();
    var idx = modelarray.indexOf(item);
    if (idx > -1) {
      setModelarray(modelarray.filter(i => i !== item))
      formData[listKey].splice(idx, 1);
      
      /*Storing Result as string*/
      formData[clientId] = modelarray?.[0];  
      setError();
    } 
  }

  const setError = () => {
    if(field.required){
      errors[clientId].invalid = modelarray.length==0?true:false;
      errors[clientId].touched = true;
      if(errors[clientId].invalid){
        errors.invalid[clientId] = true;
      }else{
        delete errors.invalid[clientId]
      }
      setShowError(!showError);
      formFn.refreshFormSubmit();
    }
  }
  
  const Error = () => {
    if(field.required && (errors[clientId].touched || errors.isSubmitted) && errors[clientId].invalid){
      return(
        <div className="errormsg">
          <div>
            <span className="fas fa-exclamation-triangle m-r-5"/>
            <RequiredMsg {...{field, currentLocale}}/>
          </div>
        </div>
      )
    }
    return null;
  }

  //FormHelper.setDisabled(field, inputAttributes);
  //FormHelper.checkFieldValidity(field, formData, errors);

  const tags = modelarray.map((t, k) =>  
    <span className="tag" key={k}>
      <span>{t}&nbsp;&nbsp;</span><a href="#" title="Removing tag" onClick={e => remove(e, t)}>x</a>
    </span>
  )

  return (
     <div {...parentAttributes} onMouseEnter={() => setShowTagsPanel(true)} onMouseLeave={() => setShowTagsPanel(false)}>
      {loading && <Spinner/>}
      <div className="flex coldir m-b-20 tooltip">
        <CueTip 
          positionCss={position>1?'top':'bottom'}
          tooltip={field.tooltip}
          currentLocale={currentLocale}
          locale={field.locale?.tooltip}/>
        <FieldLabel field={field} 
          isFormWizard={isFormWizard}
          labelAttributes={labelAttributes} 
          currentLocale={currentLocale}
          openFieldLabelModal={openFieldLabelModal}/>
        <div id="tags_input" className="tagsinput" data-tip data-for={`tooltip_${clientId}`}>
          {tags}
          <input {...inputAttributes} placeholder="add a tag" onKeyDown={onEnter} />
          <div className="tags_clear"/>
        </div>  
        {showTagsPanel &&
          <div className="m-t-5 ani-opc pointer" id="tags_panel">
            <span className="fts-13 text-muted">Select Existing tags:</span>
            <div className="tagsinput">
              <Tags list={tagList} toggle={add} modelarray={modelarray} />
            </div>
          </div>
        }
        <Description description={field.description} 
          currentLocale={currentLocale}
          locale={field.locale?.description} />
        <FieldReview review={fieldReview}/>
        <Error/>
      </div>
    </div> 
  )
}

const Tags = ({list, toggle, modelarray}) => list.map((o, k) =>
  <span key={k} className={`tag ${ modelarray.includes(o) ? '' : 'bg-ltint white'} `} onClick={e => toggle(o)}>
    <i className="fas fa-plus m-r-5 black"/>
    <strong className="black-light-1 font-500">{o}</strong>
  </span>
)
export default InputTags;
